import { List } from 'components/order/list'
import { Button } from 'avo-ui'
import { setConfirmationMessage, setModal, setOptions } from 'reducers/listReducer'
import { useDispatch, useSelector } from 'react-redux'
import icFilter from 'assets/images/ic-filter.svg'
import { useEffect, useState } from 'react'
import { SORT_ALL_REVIEW, TABLE_ALL_REVIEW } from 'configs/reviews/configAllReview'
import { useFetch } from 'services/useFetch'
import { API_REVIEW } from 'services/apiReview'
import { downloadFile, getAllQueryParams, getObjectName, getValueFromArray, setQueryParams } from 'utils/utils'
import { useLocation, useSearchParams } from 'react-router-dom'
import { RatingFilterModal } from 'components/reviews/all-review/RatingFilterModal'
import moment from 'moment/moment'
import clsx from 'clsx'
import icFilterWhite from 'assets/images/ic-filter-white.svg'
import icTrash from 'assets/images/ic-trash.svg'

export const AllReviewContainer = () => {
    const dispatch = useDispatch()
    const location = useLocation()
    const [searchParams, setSearchParams] = useSearchParams()
    const [isResetSelectedItem, setIsResetSelectedItem] = useState(false)
    const { selectedValue, modal, query: INITIAL_DATA_FILTER } = useSelector((state) => state.listReducer)
    const { data: reviewList, fetching: getReviewListApi, isLoading } = useFetch(API_REVIEW.LIST)
    const { fetching: exportReviewListApi, isLoading: isLoadingExport } = useFetch(API_REVIEW.EXPORT)
    const { fetching: deleteReviewApi, isLoading: isLoadingDeleteReview } = useFetch(API_REVIEW.DELETE)
    const query = searchParams.size > 0 ? getAllQueryParams(searchParams) : INITIAL_DATA_FILTER

    useEffect(() => {
        const newQuery = { ...query }
        if (newQuery?.ratings) newQuery['ratings'] = newQuery?.ratings?.split(',')
        getReviewListApi(newQuery)
    }, [location?.search])

    useEffect(() => {
        dispatch(
            setOptions({
                sort: SORT_ALL_REVIEW,
                table: TABLE_ALL_REVIEW,
                tab: [],
            }),
        )
    }, [])

    const onChangeQuery = (queryParams) => {
        const isReset = getObjectName(queryParams)?.some((item) => ['search', 'ratings'].includes(item))
        if (isReset) setIsResetSelectedItem(!isResetSelectedItem)
        const params = setQueryParams({ ...query, ...queryParams })
        setSearchParams(params, { replace: true })
    }

    const rightButtonConfirm = () => {
        deleteReviewApi({ review_ids: getValueFromArray(selectedValue?.selectedIds, 'id') }).then((res) => {
            setIsResetSelectedItem(!isResetSelectedItem)
            dispatch(setModal({ confirm: false }))
            getReviewListApi(query)
        })
    }

    const onExport = () => {
        const payload = { review_ids: getValueFromArray(selectedValue?.selectedIds, 'id'), ...query }
        exportReviewListApi(payload, '', {}, 'blob').then((response) => {
            downloadFile(null, response, `User-Export-${moment().format('DD-MM-YYYY')}.xlsx`)
            dispatch(setModal({ export: false }))
        })
    }

    const onCLickDelete = () => {
        dispatch(setConfirmationMessage(`Are You Sure Want to Delete This Review?`))
        dispatch(setModal({ confirm: true }))
    }

    const rightButton = () => {
        return (
            <Button
                type={'outline'}
                title={'Delete Review'}
                icon={icTrash}
                disabled={!selectedValue?.selectedIds?.length}
                onClick={onCLickDelete}
            />
        )
    }

    const filter = () => {
        const values = query?.ratings?.split(',')
        return (
            <>
                <div className={'w-fit relative'}>
                    <Button
                        className={clsx(values?.length > 0 && '!bg-blue-90 !text-white')}
                        title={'Filter'}
                        icon={values?.length > 0 ? icFilterWhite : icFilter}
                        type={'outline'}
                        onClick={() => dispatch(setModal({ filter: true }))}
                    />
                    <div
                        className={`absolute -right-1 -top-3.5 py-1 px-2.5 text-white bg-blue-95 rounded-full ${values?.length > 0 ? 'block' : 'hidden'}`}
                    >
                        {values?.length}
                    </div>
                </div>
                {modal.filter && (
                    <RatingFilterModal
                        show={modal?.filter}
                        onHide={() => dispatch(setModal({ filter: false }))}
                        values={values}
                        onFilter={(value) => {
                            onChangeQuery({ ratings: value?.join(','), page: 1 })
                            dispatch(setModal({ filter: false }))
                        }}
                    />
                )}
            </>
        )
    }

    const props = {
        dataList: reviewList?.data,
        query,
        onChangeQuery,
        isLoading,
        isLoadingConfirm: isLoadingDeleteReview,
        isLoadingExport,
        onExport,
        rightButton,
        rightButtonConfirm,
        filter,
        isResetSelectedItem,
    }

    return <List {...props} />
}
